import { render, staticRenderFns } from "./avoid-fraud.vue?vue&type=template&id=4407b6e1"
import script from "./avoid-fraud.vue?vue&type=script&lang=js"
export * from "./avoid-fraud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports